export const SERVER_URL_CATALOGO = process.env.VUE_APP_SERVER_URL_CATALOGO;
export const SERVER_URL_ISTANZE = process.env.VUE_APP_SERVER_URL_ISTANZE;
export const SERVER_URL_REPO = process.env.VUE_APP_SERVER_URL_REPO;
export const SERVER_URL_LOGIN = process.env.VUE_APP_SERVER_URL_LOGIN;
export const FRONTEND_ROOT = process.env.VUE_APP_FRONTEND_ROOT;
